<template>
    <div class="view-container">
        <systems-filter
            :initialClicked="'Active'"
            @modeChanged="(mode) => getData(mode)"
            @fit="fitEverything"
            :mapFitButton="true"
            :shouldZoom="shouldZoom"
        ></systems-filter>
        <div id="map-container" class="grid-filters map-grid">
            <div id="map"></div>
            <div id="system-info" class="system-info-container">
                <div>
                    <h4>
                        {{
                            selectedSystem == null
                                ? $t("No_system_selected")
                                : selectedSystem.systemName
                        }}
                    </h4>
                    <div v-if="selectedSystem != null" style="">
                        <div class="system-details-container">
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width: 200px">
                                        <p class="info-field-title">
                                            {{ $t("SystemStatus") }}
                                        </p>
                                    </td>
                                    <td
                                        style="width: 200px"
                                        class="info-field-value"
                                    >
                                        <div class="info-field-text">
                                            {{
                                                selectedSystem.systemStatusDescription
                                            }}
                                        </div>
                                    </td>
                                </tr>
                            </div>
                            <h5>{{ $t("BaseInfo") }}</h5>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width: 200px">
                                        <p class="info-field-title">
                                            {{ $t("FarmName") }}
                                        </p>
                                    </td>
                                    <td
                                        style="width: 200px"
                                        class="info-field-value"
                                    >
                                        <div class="info-field-text">
                                            {{ selectedSystem.farmName }}
                                        </div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width: 200px">
                                        <p class="info-field-title">
                                            {{ $t("Group") }}
                                        </p>
                                    </td>
                                    <td
                                        style="width: 200px"
                                        class="info-field-value"
                                    >
                                        <div class="info-field-text">
                                            {{ selectedSystem.farmGroup }}
                                        </div>
                                    </td>
                                </tr>
                            </div>
                            <div class="info-field horizontal">
                                <tr class="info-field-row">
                                    <td style="width: 200px">
                                        <p class="info-field-title">
                                            {{ $t("FarmAddress") }}
                                        </p>
                                    </td>
                                    <td
                                        style="width: 200px"
                                        class="info-field-value"
                                    >
                                        <div class="info-field-text">
                                            {{ selectedSystem.farmAddress }}
                                        </div>
                                    </td>
                                </tr>
                            </div>
                        </div>
                        <div
                            v-if="
                                selectedSystem.contactPersonLastName != '' ||
                                selectedSystem.farmOwnerLastName != ''
                            "
                        >
                            <h5>{{ $t("Contact") }}</h5>
                            <div
                                v-if="
                                    selectedSystem.contactPersonLastName != ''
                                "
                            >
                                <h6>{{ $t("ContactPerson") }}</h6>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("Name") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.contactPersonFirstName
                                                }}
                                                {{
                                                    selectedSystem.contactPersonLastName
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("Responsibility") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.contactPersonResponsibility
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("PhoneNumber") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.contactPersonPhoneNumber
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("Email") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.contactPersonEmail
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                            </div>
                            <div v-if="selectedSystem.farmOwnerLastName != ''">
                                <h6>{{ $t("FarmOwner") }}</h6>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("Name") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.farmOwnerFirstName
                                                }}
                                                {{
                                                    selectedSystem.farmOwnerLastName
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("Responsibility") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.farmOwnerResponsibility
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("PhoneNumber") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.farmOwnerPhoneNumber
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                                <div class="info-field horizontal">
                                    <tr class="info-field-row">
                                        <td style="width: 200px">
                                            <p class="info-field-title">
                                                {{ $t("Email") }}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 200px"
                                            class="info-field-value"
                                        >
                                            <div class="info-field-text">
                                                {{
                                                    selectedSystem.farmOwnerEmail
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Button
                        v-if="selectedSystem != null"
                        :title="$t('GoToSystem')"
                        buttonClass="save-button semi-bold"
                        style="width: 100%; align-self: center"
                        @onClick="goToSystemView()"
                    ></Button>
                </div>
            </div>
            <div class="mobile-map-bottom" style="height: 20px"></div>
        </div>
    </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

import { getSystemsCoordinates } from "@api";
import SystemsFilter from "../components/Systems/SystemsFilter.vue";
import Button from "../components/Button.vue";

export default {
    components: {
        SystemsFilter,
        Button,
    },
    data() {
        return {
            map: null,
            systemCoordinates: [],
            selectedSystem: null,
            currentPopup: null,

            statusHTML: [
                `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM10.9983 5.06444C11.3079 5.33963 11.3357 5.81369 11.0606 6.12327L7.06056 10.6233C6.91823 10.7834 6.71423 10.875 6.5 10.875C6.28577 10.875 6.08177 10.7834 5.93944 10.6233L3.93944 8.37327C3.66425 8.06369 3.69214 7.58963 4.00173 7.31444C4.31131 7.03925 4.78537 7.06714 5.06056 7.37673L6.5 8.9961L9.93944 5.12673C10.2146 4.81714 10.6887 4.78925 10.9983 5.06444Z" fill="#1ECD74"/></svg>`,
                `<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 8.35851C7.09965 8.35851 6.77511 8.04279 6.77511 7.65332V5.53776C6.77511 5.1483 7.09965 4.83258 7.5 4.83258C7.90035 4.83258 8.22489 5.1483 8.22489 5.53776V7.65332C8.22489 8.04279 7.90035 8.35851 7.5 8.35851Z" fill="#FFB800"/><path d="M6.41266 10.1215C6.41266 9.53728 6.89948 9.06369 7.5 9.06369C8.10052 9.06369 8.58734 9.53728 8.58734 10.1215C8.58734 10.7057 8.10052 11.1793 7.5 11.1793C6.89948 11.1793 6.41266 10.7057 6.41266 10.1215Z" fill="#FFB800"/><path d="M6.21706 0.753497C6.7606 -0.251162 8.2394 -0.251169 8.78294 0.753496L14.8312 11.9327C15.3393 12.8719 14.6392 14 13.5482 14H1.45176C0.360783 14 -0.3393 12.8719 0.168819 11.9328L6.21706 0.753497ZM13.5482 12.5896L7.5 1.41037L1.45176 12.5896L13.5482 12.5896Z" fill="#FFB800"/></svg>`,
                `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.34467 4.34467C4.63756 4.05178 5.11244 4.05178 5.40533 4.34467L7.5 6.43934L9.59467 4.34467C9.88756 4.05178 10.3624 4.05178 10.6553 4.34467C10.9482 4.63756 10.9482 5.11244 10.6553 5.40533L8.56066 7.5L10.6553 9.59467C10.9482 9.88756 10.9482 10.3624 10.6553 10.6553C10.3624 10.9482 9.88756 10.9482 9.59467 10.6553L7.5 8.56066L5.40533 10.6553C5.11244 10.9482 4.63756 10.9482 4.34467 10.6553C4.05178 10.3624 4.05178 9.88756 4.34467 9.59467L6.43934 7.5L4.34467 5.40533C4.05178 5.11244 4.05178 4.63756 4.34467 4.34467Z" fill="#FF3737"/></svg>`,
            ],
            bounds: [
                [0, 0],
                [0, 0],
            ],
            resizeObs: null,
            initialZoom: 2,
            shouldZoom: false,
            maxAnimationDuration: 500,
            lastMode: "Active",
            refreshTimer: null,
            refreshIntervalMs: 60000,
        };
    },
    methods: {
        buildPopupHtml(e) {
            const statusTab =
                typeof e.statusTab === "string"
                    ? JSON.parse(e.statusTab)
                    : e.statusTab;

            if (e.systemStatus == 5) {
                return `<div style="margin-bottom: 15px; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 14px; align-self: center;"> ${
                        e.systemName
                    } </div>
                    <div> ${this.$t("SystemStatus")}: <b> ${
                    e.systemStatusDescription
                } </b></div>
                </div>
                <div class="modal-slot vertical">
                    <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                        <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                            "AlarmsCRFI"
                        )} </div>
                        <div style="margin-left: 10px;">
                            ${this.statusHTML[statusTab[0]]}
                        </div>
                    </div>
                    <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                        <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                            "AlarmsMonitoring"
                        )} </div>
                        <div style="margin-left: 10px;">
                            ${this.statusHTML[statusTab[1]]}
                        </div>
                    </div>
                </div>`;
            }

            if (e.systemStatus == 3 || e.systemStatus == 4) {
                return `<div style="margin-bottom: 15px;">
                    <div style="font-weight: bold; font-size: 14px; align-self: center;"> ${
                        e.systemName
                    } </div>
                    <div> ${this.$t("SystemStatus")}: <b> ${
                    e.systemStatusDescription
                } </b></div>
                </div>`;
            }

            return `<div style="margin-bottom: 15px; padding-left: 10px; padding-right: 10px;">
                <div style="font-weight: bold; font-size: 14px; align-self: center;"> ${
                    e.systemName
                } </div>
            </div>
            <div class="modal-slot vertical">
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "General"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[1]]}
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "BlackBox"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[2]]}
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "Device"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[3]]}
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "Rapid24"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[4]]}
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "Photocells"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[5]]}
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "Pressure"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[6]]}
                    </div>
                </div>
                <div class="horizontal" style="border-bottom: 1px solid #E9E9E9; justify-content: space-between; padding-left: 10px; padding-right: 10px;">
                    <div style="font-weight: bold; font-size: 12px;"> ${this.$t(
                        "Database"
                    )} </div>
                    <div style="margin-left: 10px;">
                        ${this.statusHTML[statusTab[7]]}
                    </div>
                </div>
            </div>`;
        },
        loadMarkerImage(name, color, innerColor) {
            return new Promise((resolve) => {
                if (this.map.hasImage(name)) {
                    resolve();
                    return;
                }
                const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="27" height="41" viewBox="0 0 27 41">
                    <path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.074644 6.7499993,27.000002 12.25,34.500002 C13,35.500004 14.016665,35.500004 14.75,34.500002 C20.250001,27.000002 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z" fill="${color}" stroke="rgba(0,0,0,0.25)" stroke-width="1"/>
                    <circle fill="${innerColor || "#FFFFFF"}" cx="13.5" cy="13.5" r="5.5"/>
                </svg>`;
                const img = new Image(27, 41);
                img.onload = () => {
                    if (!this.map.hasImage(name)) {
                        this.map.addImage(name, img);
                    }
                    resolve();
                };
                img.onerror = () => resolve();
                img.src =
                    "data:image/svg+xml;charset=utf-8," +
                    encodeURIComponent(svg);
            });
        },
        loadMarkerImages() {
            return Promise.all([
                this.loadMarkerImage("system-marker-ok", "#159C56"),
                this.loadMarkerImage("system-marker-warning", "#FFB800"),
                this.loadMarkerImage("system-marker-error", "#FF3737"),
                this.loadMarkerImage("system-marker-off", "#FFFFFF", "#AAAAAA"),
                this.loadMarkerImage("system-marker-down", "#1A1A1A"),
                this.loadMarkerImage("system-marker-inactive", "#AAAAAA"),
            ]);
        },
        getMarkerStatus(e) {
            // Wyłączone alarmy (CRFI lub monitoring) -> biały
            if (e.systemStatus === 5) {
                return "off";
            }

            // System down -> czarny
            if (e.systemStatus === 4) {
                return "down";
            }

            const statusTab = Array.isArray(e.statusTab) ? e.statusTab : [];

            // Brak monitoringu / system down -> szary
            if (statusTab.length === 0 || statusTab.includes(3)) {
                return "inactive";
            }

            const worst = statusTab.reduce(
                (max, s) => (typeof s === "number" && s > max ? s : max),
                0
            );

            if (worst >= 2) return "error";
            if (worst === 1) return "warning";
            return "ok";
        },
        async setupClusterLayers() {
            await this.loadMarkerImages();

            this.map.addSource("systems", {
                type: "geojson",
                data: { type: "FeatureCollection", features: [] },
            });

            this.map.addLayer({
                id: "unclustered-point",
                type: "symbol",
                source: "systems",
                layout: {
                    "icon-image": [
                        "match",
                        ["get", "markerStatus"],
                        "ok",
                        "system-marker-ok",
                        "warning",
                        "system-marker-warning",
                        "error",
                        "system-marker-error",
                        "off",
                        "system-marker-off",
                        "down",
                        "system-marker-down",
                        "system-marker-inactive",
                    ],
                    "icon-size": 0.7,
                    "icon-anchor": "bottom",
                    "icon-allow-overlap": true,
                    "icon-ignore-placement": true,
                },
            });

            this.map.on("click", "unclustered-point", (ev) => {
                const feature = ev.features[0];
                const props = feature.properties;
                const coordinates = feature.geometry.coordinates.slice();
                const statusTab =
                    typeof props.statusTab === "string"
                        ? JSON.parse(props.statusTab)
                        : props.statusTab;
                const system = { ...props, statusTab };

                if (this.currentPopup) {
                    this.currentPopup.remove();
                }
                this.currentPopup = new mapboxgl.Popup({ offset: 25 })
                    .setLngLat(coordinates)
                    .setHTML(this.buildPopupHtml(system))
                    .addTo(this.map);

                this.selectedSystem = system;
            });

            const setPointerCursor = () => {
                this.map.getCanvas().style.cursor = "pointer";
            };
            const clearCursor = () => {
                this.map.getCanvas().style.cursor = "";
            };
            this.map.on("mouseenter", "unclustered-point", setPointerCursor);
            this.map.on("mouseleave", "unclustered-point", clearCursor);
        },
        async getData(mode, silent = false) {
            if (mode != undefined && mode != null) {
                this.lastMode = mode;
            }

            this.systemCoordinates = await getSystemsCoordinates(this.lastMode);

            const padding = 5;

            const filtered = this.systemCoordinates.filter((e) => {
                return !(
                    (Math.abs(e.addressLongitude) < 0.1 &&
                        Math.abs(e.addressLatitude) < 0.1) ||
                    e.farmName.includes("BioControl") ||
                    e.farmGroup == "BioControl"
                );
            });

            filtered.forEach((e) => {
                try {
                    if (e.farmAddress == "") {
                        e.farmAddress = "-";
                    } else if (e.farmAddress.trim().endsWith(",")) {
                        e.farmAddress += " " + e.farmCountry;
                    } else {
                        e.farmAddress += ", " + e.farmCountry;
                    }
                } catch (ex) {
                    console.log(e);
                }
            });

            const features = filtered.map((e) => ({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [e.addressLongitude, e.addressLatitude],
                },
                properties: {
                    ...e,
                    markerStatus: this.getMarkerStatus(e),
                    statusTab: JSON.stringify(e.statusTab),
                },
            }));

            const source = this.map.getSource("systems");
            if (source) {
                source.setData({
                    type: "FeatureCollection",
                    features,
                });
            }

            // Przy cichym odświeżaniu nie zamykamy otwartego popupu,
            // żeby nie przerywać użytkownikowi podglądu systemu.
            if (!silent && this.currentPopup) {
                this.currentPopup.remove();
                this.currentPopup = null;
            }

            this.map.resize();

            if (filtered.length === 0) return;

            const lngs = filtered.map((x) => x.addressLongitude);
            const lats = filtered.map((x) => x.addressLatitude);

            let maxLng = Math.max(...lngs);
            let minLng = Math.min(...lngs);
            let minLat = Math.min(...lats);
            let maxLat = Math.max(...lats);

            let latDiff = (maxLat - minLat) * (padding / 100);
            let lngDiff = (maxLng - minLng) * (padding / 100);

            this.bounds = [
                [minLng - lngDiff, minLat - latDiff],
                [maxLng + lngDiff, maxLat + latDiff],
            ];

            // Przy cichym odświeżaniu nie ruszamy kamery (bez przeskoku widoku).
            if (silent) return;

            this.map.fitBounds(this.bounds, {
                linear: true,
                maxDuration: this.maxAnimationDuration,
            });

            setTimeout(() => {
                this.initialZoom = this.map.getZoom();

                let currentZoom = this.map.getZoom();
                let down = this.initialZoom - 0.25;
                let up = this.initialZoom + 0.25;
                this.shouldZoom = currentZoom < down || currentZoom > up;
            }, 500);
        },
        fitEverything() {
            this.map.resize();
            this.map.fitBounds(this.bounds, {
                linear: true,
                maxDuration: this.maxAnimationDuration,
            });
        },
        goToSystemView() {
            this.$router.push({
                name: "settingsGeneral",
                params: {
                    systemName: this.selectedSystem.systemName,
                    systemId: this.selectedSystem.systemId,
                },
            });
        },
    },
    mounted: async function () {
        mapboxgl.accessToken =
            "pk.eyJ1Ijoicml2aWpjenlrOTgiLCJhIjoiY2thNWxvYnZ4MDFhcjNtbXdlOGRkZHlpNyJ9.3yvf9A68MAvVM9OG1ZK9pg";
        this.map = new mapboxgl.Map({
            container: "map", // container ID
            style: "mapbox://styles/mapbox/streets-v11", // style URL
            center: [21, 52], // starting position [lng, lat]
            zoom: 2, // starting zoom
        });

        this.map.on("zoom", () => {
            let currentZoom = this.map.getZoom();
            let down = this.initialZoom - 0.25;
            let up = this.initialZoom + 0.25;
            this.shouldZoom = currentZoom < down || currentZoom > up;
            // console.log({init: this.initialZoom, down, up, currentZoom, should: this.shouldZoom})
        });

        this.map.addControl(new mapboxgl.NavigationControl());
        this.map.addControl(new mapboxgl.FullscreenControl());

        this.map.on("load", async () => {
            await this.setupClusterLayers();
            await this.getData();

            // Automatyczne, bezszwowe odświeżanie danych w tle.
            this.refreshTimer = setInterval(() => {
                this.getData(null, true);
            }, this.refreshIntervalMs);
        });

        this.resizeObs = new ResizeObserver((entr) => {
            this.map.resize();

            if (!this.shouldZoom) {
                this.map.fitBounds(this.bounds, {
                    linear: true,
                    maxDuration: this.maxAnimationDuration,
                });
            }
        });

        this.resizeObs.observe(document.querySelector("#map-container"));
    },
    beforeDestroy() {
        if (this.refreshTimer != null) {
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }

        var element = document.querySelector("#map-container");
        if (element != null) {
            this.resizeObs.unobserve(element);
        }
    },
};
</script>

<style scoped>
.map-grid {
    display: grid;
    grid-template-columns: 80% 20%;
}

#map {
    width: 98%;
    height: 100%;
    min-height: 50vh;
    position: relative;
    border-radius: 4px;
    margin: auto auto;
}

.system-info-container {
    background-color: rgba(243, 243, 243, 1);
    padding: 20px;
    border: 1px solid rgba(224, 224, 224, 1);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.system-details-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.info-field-text {
    font-weight: bolder;
    word-break: break-word;
}

.mobile-map-bottom {
    display: none;
}

.grid-filters {
    height: calc(100vh - 228px);
    max-height: calc(100vh - 228px);
}

@media only screen and (max-width: 700px) {
    .map-grid {
        grid-template-columns: unset;
    }

    .map-grid.grid-filters {
        height: unset;
    }

    #map {
        min-height: 60vh;
    }

    .system-info-container {
        margin: 10px 0;
    }

    .mobile-map-bottom {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/MapBoxView.vue